import alertSuccess from './imgs/alert_success.png'
import alertFail from './imgs/alert_fail.png'
import load from './imgs/loading.gif'
import './Alert.scss'
export var alertObj = new Object()

var alertPlaceholder = document.getElementById('liveAlertPlaceholder')
var alertTrigger = document.getElementById('liveAlertBtn')

alertObj.alert = function (message, type) {
  var wrapper = document.createElement('div')
  wrapper.innerHTML =
    '<div class="alert alert-' +
    type +
    ' alert-dismissible" role="alert">' +
    message +
    '<button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button></div>'
  alertPlaceholder.append(wrapper)
  return alertPlaceholder
}

if (alertTrigger) {
  alertTrigger.addEventListener('click', function () {
    alert('Nice, you triggered this alert message!', 'success')
  })
}


var bgViewStyle = {

  position: 'absolute',
  width: '300px',
  height: '300px',
  borderRadius: '12px',
  background: '#FFFFFF',
 
}


var imgStyle = {
  position: 'absolute',
  width: '180px',
  height: '180px',
  marginTop: '31px',
  marginLeft: '60px',
}
var txtStyle = {
  textAlign: 'center',
  height: '25px',
  width: '100%',
  color: '#BBB1A7',
  marginTop: '220px',
}

alertObj = {
  
  bgViewSet: bgViewStyle,
  txtSet: txtStyle,
  imgSet: imgStyle,
  isExist: false,
}
alertObj.createComponent = function () {
  var component = document.createElement(arguments[0])
  var styles = arguments[1]
  for (var property in styles) {
    if (styles[property] != null) {
      try {
        component.style[property] = styles[property]
      } catch (err) {
        document.write(err.name + ':' + property + '<br/>') //set property error!
      }
    }
  }
  return component
}

alertObj.hideLoad = function () {
  var bodyObj = document.body
  var div = document.getElementById('loadAlert')

  if (div) {

    bodyObj.removeChild(div)

    alertObj.isExist = false
    // bodyObj.style.background = ''
    // document.getElementById("appNavigation").style.background = '#FFFCF7'
  }

}

alertObj.showLoad = function () {

  if (this.isExist) { this.hideLoad() }

  this.isExist = true
  var bodyObj = document.body

  // bodyObj.style.background = '#999'

  var generalStyle = {

    position: 'absolute',
    zIndex: 10000,
    width: '100%',
    top: '0px',
    height: document.body.scrollHeight + 80 + 'px',
    background: 'rgba(0, 0, 0, 0.4)',

  }

  var windowViewStyle = {

    position: 'absolute',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100vh',

    top: document.body.scrollTop + document.documentElement.scrollTop + 'px',
  }

  var bgViewStyle = {

    position: 'absolute',
    width: '300px',
    height: '300px',
    borderRadius: '12px',


  }

  var imgStyle = {
    position: 'absolute',
    width: '180px',
    height: '180px',
    marginTop: '60px',
    marginLeft: '60px',

  }

  if (document.body.scrollWidth < 577) {

    bgViewStyle = {

      position: 'absolute',
    width: '160px',
    height: '160px',
    borderRadius: '12px',
    // background: '#FFFFFF',
    }

    imgStyle = {
      position: 'absolute',
      width: '78px',
      height: '78px',
      marginTop: '41px',
      marginLeft: '41px',
    }
  }

  var divView = this.createComponent('div', generalStyle)
  divView.id = "loadAlert"
  var windowView = this.createComponent('div', windowViewStyle)
  var bgView = this.createComponent('div', bgViewStyle)
  var imgObj = this.createComponent('img', imgStyle)
  imgObj.src = load
  divView.appendChild(windowView)
  windowView.appendChild(bgView)
  bgView.appendChild(imgObj)
  bodyObj.appendChild(divView)
}

alertObj.show = function (msg, type, isReturn) {
  if (!this.isExist) {
    this.isExist = true
    var bodyObj = document.body
    // bodyObj.style.zIndex = -1
    // bodyObj.style.background = '#999'
    // document.getElementById("appNavigation").style.background = '#999'
    var generalStyle = {

      position: 'absolute',
      zIndex:10000,
      width: '100%',
      top:'0px',
      height:document.body.scrollHeight + 80 + 'px',
      background:'rgba(0, 0, 0, 0.4)',

    }

    var windowViewStyle = {

      position: 'absolute',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      height: '100vh',
     
      top: document.body.scrollTop + document.documentElement.scrollTop + 'px',
    }

    var bgViewStyle = {

      position: 'absolute',
      width: '300px',
      height: '300px',
      borderRadius: '12px',
      background: '#FFFFFF',
    
    }
    
    
    var imgStyle = {
      position: 'absolute',
      width: '180px',
      height: '180px',
      marginTop: '31px',
      marginLeft: '60px',
    }
    var txtStyle = {
      textAlign: 'center',
      height: '25px',
      width: '100%',
      color: '#BBB1A7',
      marginTop: '220px',
      fontSize:'22px',
    }

    if (document.body.scrollWidth < 577) {

      bgViewStyle = {

        position: 'absolute',
      width: '160px',
      height: '160px',
      borderRadius: '12px',
      background: '#FFFFFF',
      }

      imgStyle = {
        position: 'absolute',
        width: '78px',
        height: '78px',
        marginTop: '26px',
        marginLeft: '41px',
      }

      txtStyle = {
        textAlign: 'center',
        height: '14px',
        width: '100%',
        color: '#BBB1A7',
        marginTop: '117px',
        fontSize:'12px',
      }
    }

    

    var divView = this.createComponent('div', generalStyle)
    var windowView = this.createComponent('div',windowViewStyle)
    var bgView = this.createComponent('div', bgViewStyle)
    var txtObj = this.createComponent('p', txtStyle)
    txtObj.innerHTML = msg
    var imgObj = this.createComponent('img', imgStyle)


    if (type === 0) {
      imgObj.src = alertSuccess
    } else {
      imgObj.src = alertFail
    }
    divView.appendChild(windowView)
    windowView.appendChild(bgView)
    bgView.appendChild(imgObj)
    bgView.appendChild(txtObj)
    bodyObj.appendChild(divView)


    setTimeout(() => {

      bodyObj.removeChild(divView)

      // bodyObj.style.zIndex = 0
      alertObj.isExist = false
      // bodyObj.style.background = ''
      // document.getElementById("appNavigation").style.background = '#FFFCF7'
      if (isReturn) {

        window.location.href = "/"
      }

    }, 3000)
  }
}
